import React, { useState, useEffect } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import { API_CONSTANTS } from "../../../utils/AppConstants";
import { merchantDetailRequest, updateMerchantDetailsRequest, updateMerchantDetailsRequestStatus } from '../../../redux/merchant/merchant.action'
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import CommonInputFloatHalf from "../../../components/input/common-input-float-half/commonInputFloafHalf";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";

const MerchantDetail = props => {
    const { state } = useLocation()
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const { merchantDetailSuccess, merchantDetailError,
        updateMerchantDetailSuccess, updateMerchantDetailError, updateMerchantDetailReqStatus } = useSelector(state => state.merchant)
    const [name, setName] = useState('')
    const [contactPersonName, setContactPersonName] = useState('')
    const [contactPersonNumber, setContactPersonNumber] = useState('')
    const [contactPersonEmail, setContactPersonEmail] = useState('')
    const [address, setAddress] = useState('')
    const [taxType, setTaxType] = useState('')
    const [taxTypeValue, setTaxTypeValue] = useState('')
    const [paymentTerms, setPaymentTerms] = useState('')
    const [isActive, setIsActive] = useState(true)

    useEffect(() => {
        fetchMerchantDetails()
    }, [])

    const fetchMerchantDetails = () => {
        setLoading(true)
        dispatch(merchantDetailRequest(state))
    }

    useEffect(() => {
        if (!isEmpty(merchantDetailSuccess)) {
            setLoading(false)
            setContentValues(merchantDetailSuccess.data)
        } else if (!isEmpty(merchantDetailError)) {
            setLoading(false)
        }
    }, [merchantDetailSuccess, merchantDetailError])

    useEffect(() => {
        if (updateMerchantDetailReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateMerchantDetailSuccess.data?.message)
            fetchMerchantDetails()
        } else if (updateMerchantDetailReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateMerchantDetailError.message)
        }
        if (updateMerchantDetailReqStatus?.length) {
            dispatch(updateMerchantDetailsRequestStatus(''))
        }
    }, [updateMerchantDetailSuccess, updateMerchantDetailError, updateMerchantDetailReqStatus])

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_MERCHANT) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.SUPPLIES, PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_MERCHANT, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    const setContentValues = (data) => {
        setName(data.name)
        setContactPersonName(data.contactPersonName)
        setContactPersonNumber(data.contactPersonNumber)
        setContactPersonEmail(data.contactPersonEmail)
        setAddress(data.address)
        setIsActive(data.isActive)
        setTaxType(data.taxIdType)
        setTaxTypeValue(data.taxId)
        setPaymentTerms(data.paymentTerms)
    }

    const handleUpdateClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Merchant name cannot be blank')
        } else if (isEmpty(contactPersonName)) {
            displayErrorToast('Contact person name cannot be blank')
        } else if (isEmpty(contactPersonNumber)) {
            displayErrorToast('Contact person number cannot be blank')
        } else if (isEmpty(contactPersonEmail)) {
            displayErrorToast('Contact person email cannot be blank')
        } else if (isEmpty(address)) {
            displayErrorToast('Merchant address cannot be blank')
        } else {
            setLoading(true)
            const data = {
                merchantId: state,
                name: name,
                contactPersonName: contactPersonName,
                contactPersonEmail: contactPersonEmail,
                contactPersonNumber: contactPersonNumber,
                address: address,
                isActive: isActive
            }
            if (!isEmpty(paymentTerms)) {
                data.paymentTerms = paymentTerms
            }
            if (!isEmpty(taxType) && !isEmpty(taxTypeValue)) {
                data.taxIdType = taxType
                data.taxId = taxTypeValue
            }
            dispatch(updateMerchantDetailsRequest(data))
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Merchant Details' />
                {!isEmpty(merchantDetailSuccess) && <CommonFormBorder>
                    <SubTextLabel label='Enter details to update merchant information' />
                    <CommonInputFloatFull
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Merchant Name'
                        type='text'
                        value={name}
                        isSubtext={true}
                        subText='Ex. Merchant name or Merchant business name' />
                    <FormFieldLabel label='Contact Person Details' />
                    <CommonInputFloatFull
                        id='contactPersonName'
                        onChange={e => setContactPersonName(e.target.value)}
                        placeholder='Name'
                        type='text'
                        value={contactPersonName} />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            id='contactPersonNumber'
                            onChange={e => setContactPersonNumber(e.target.value)}
                            placeholder='Contact Number'
                            type='text'
                            value={contactPersonNumber} />
                        <CommonInputFloatHalf
                            id='contactPersonEmail'
                            onChange={e => setContactPersonEmail(e.target.value)}
                            placeholder='Contact Email'
                            type='text'
                            value={contactPersonEmail} />
                    </CommonInputRow>
                    <CommonInputFloatFull
                        id='address'
                        onChange={e => setAddress(e.target.value)}
                        placeholder='Address'
                        type='text'
                        value={address}
                        isSubtext={true}
                        subText='Street address only' />
                    <FormFieldLabel label='Additional Details' />
                    <CommonCheckbox
                        id='isActive'
                        label='Is merchant active'
                        value={isActive}
                        onChange={() => {
                            setIsActive(!isActive)
                        }}
                    />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            id='taxType'
                            onChange={e => setTaxType(e.target.value)}
                            placeholder='Tax ID Type'
                            type='text'
                            value={taxType} />
                        <CommonInputFloatHalf
                            id='taxTypeValue'
                            onChange={e => setTaxTypeValue(e.target.value)}
                            placeholder='Tax ID'
                            type='text'
                            value={taxTypeValue} />
                    </CommonInputRow>
                    <CommonInputFloatFull
                        id='paymentTerms'
                        onChange={e => setPaymentTerms(e.target.value)}
                        placeholder='Payment Terms'
                        type='text'
                        value={paymentTerms}
                        multiline={true}
                        rows={4} />
                </CommonFormBorder>}
                {isPermissionAllowed(PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_MERCHANT) && <ButtonRow>
                    <CommonButton label='Update Details' onClick={() => { handleUpdateClick() }} />
                </ButtonRow>}
            </CommonScreenContent>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default MerchantDetail